// Ported from docs/ClaudeDesign/utils.js with TS types and Toronto-aware formatting.

const ET_FORMATTER = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Toronto",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

const ET_DATE_FORMATTER = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Toronto",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function fmtET(d: Date | string | null | undefined): string {
  if (d == null) return "—";
  const date = typeof d === "string" ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return "—";
  return ET_FORMATTER.format(date).replace(",", "") + " ET";
}

export function fmtETDate(d: Date | string | null | undefined): string {
  if (d == null) return "—";
  const date = typeof d === "string" ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return "—";
  return ET_DATE_FORMATTER.format(date);
}

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * A calendar date that has no time or zone (e.g. a Work Order start date, "2026-05-12"). Shown as-is
 * in the same yyyy-MM-dd style as {@link fmtETDate}; never goes through `new Date()`, which would
 * read it as UTC midnight and show the previous day in Toronto.
 */
export function fmtDateOnly(s: string | null | undefined): string {
  if (s == null) return "—";
  const day = s.slice(0, 10);
  return DATE_ONLY.test(day) ? day : "—";
}

export function fmtDur(n: number | null | undefined, unit: "bd" | "d" = "bd"): string {
  if (n == null || !Number.isFinite(n)) return "—";
  return `${n.toFixed(2)} ${unit}`;
}

/**
 * Business days as the dashboard shows them: whole days, so a clock reads the same next to the
 * Operations drawer, the attention pill and the banner (all whole-day clocks). Under half a day
 * reads "< 1 bd". Two decimals stay in the stage timing table and the tasks fold, where sub-day
 * stages matter.
 */
export function fmtWholeBd(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "—";
  return n < 0.5 ? "< 1 bd" : `${Math.round(n)} bd`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}
